import CalendarLocale from 'bonree-picker/lib/locale/zh_CN';
import TimePickerLocale from '../../time-picker/locale/zh_CN';
// 统一合并为完整的 Locale
const locale = {
    lang: Object.assign({ placeholder: '请选择日期', yearPlaceholder: '请选择年份', quarterPlaceholder: '请选择季度', monthPlaceholder: '请选择月份', weekPlaceholder: '请选择周', rangePlaceholder: ['开始日期', '结束日期'], rangeYearPlaceholder: ['开始年份', '结束年份'], rangeMonthPlaceholder: ['开始月份', '结束月份'], rangeWeekPlaceholder: ['开始周', '结束周'] }, CalendarLocale),
    timePickerLocale: Object.assign({}, TimePickerLocale),
    globalPickerLocale: {
        last5minutes: '最近5分钟',
        last10minutes: '最近10分钟',
        last30minutes: '最近30分钟',
        last1hour: '最近1小时',
        last3hours: '最近3小时',
        last6hours: '最近6小时',
        last12hours: '最近12小时',
        last24hours: '最近24小时',
        last2days: '最近2天',
        last3days: '最近3天',
        last7days: '最近7天',
        last30days: '最近30天',
        last90days: '最近90天',
        last6months: '最近6个月',
        last1year: '最近1年',
        today: '今天',
        yesterday: '昨天',
        thisDayLastWeek: '上周今日',
        thisWeek: '本周',
        previousWeek: '上周',
        thisMonth: '本月',
        previousMonth: '上个月',
        thisYear: '今年',
        previousYear: '去年',
        year: '年',
        month: '月',
        day: '天',
        hour: '小时',
        minute: '分钟',
        minutes: '分钟',
        second: '秒',
        noRefresh: '不刷新',
        noRecord: '暂无记录',
        timeRange: '选定的时间范围',
        invalidTimeRange: '无法预估时间范围',
        preTimeRange: '往前的时间范围',
        nextTimeRange: '往后的时间范围',
        noFuture: '不能到未发生的时间',
        noGreater: '时间区间不能大于',
        noEqual: '开始时间必须早于结束时间',
        shortcut: '快捷',
        custom: '自定义',
        recentlyUsed: '最近使用',
        viewHelp: '需要帮助请点击右侧图标，查看时间选择器指南！',
        guide: '帮助指南',
        tutorialsContent: `定义一个时间范围需提供一个开始时间和一个截止时间，并通过波浪号~连接。当仅输入一个时间点时，会将其认作开始时间，同时默认now为截止时间。now代表的时间随刷新频次进行更新。
    时间的输入支持绝对时间和相对时间两种形式，对于这两种形式的解释和示例如下。`,
        absoluteTime: '绝对时间',
        absoluteTimeContent: `确切的时间点，包括日期和时间，即年月日时分秒。与时间选择器手动点选的效果一致。
    支持输入格式：YYYY-MM-DD hh:mm:ss
    若提供了时间，而日期全部缺省或缺省日月，则按当前年月日补充；若为不够精确的输入，则按照输入日期/日期时间的起始点补全。
    支持的缺省对应补充情况示例（假设 now=2021-05-25 11:02:45）：
    ● 2020 14:34 ~ 13:45
    认定为 2020-05-25 14:34:00 至 2021-05-25 13:45:00。提供了时间，年月日部分缺省及全部缺省，填补今日；秒缺省导致精度不够，填00。
    ● 2021 和 2021-04 以及2021-04-03
    认定为2021-01-01 00:00:00至今（2021-05-25 11:02:45） 和 2021-04-01 00:00:00至今 以及 2021-04-03 00:00:00至今。时间缺省，且缺省部分日期，为不够精确的输入，按起始时间补全。`,
        relativeTime: '相对时间',
        relativeTimeConent: `相对于当前时刻（now）算出的时间点，比如：一周前、一个半小时前。
    支持的单位（unit）: s（秒）、m（分钟）、h（小时）、d（天）、w（周）、M（月）、y（年）
    支持的关键词：now
    支持的运算符：-、/<unit>
    算术运算符-、+表示与now（当前时间点）相关的对时间的运算。一小时前可表示为now-1h 或 -1h。用/<unit>格式的表达式表示定位至特定时间单位的起始日期或时间。
    支持的输入情况示例（假设 now=2021-05-25 11:02:45）：
    ● -1w ~ now
    认定为 2021-05-18 11:02:45 至今（2021-05-25 11:02:45）。一周前的现在至今。
    ● -1M ~ -1h29m
    认定为2021-04-25 11:02:45 至 2021-05-25 09:33:45。首位的now可省略，一个月前的现在至1小时29分前。
    ● -3d/d 和 now/d 以及 -1M/w
    认定为2021-05-22 00:00:00 至今 和 2021-05-25 00:00:00 至今 以及 2021-04-19 00:00:00 至今。三天前当日的开始至今，现在当日的开始至今，以及一个月前该周的开始至今。
    ● -1d/d ~ now - 7h2m45s
    认定为2021-05-24 00:00:00 至 2021-05-25 04:00:00。
    通过运算符自定义一个灵活的相对时间范围。`,
        liveTail: 'Live Tail',
        liveTailContent: '实时查看接入的所有日志数据',
        recent: '最近',
        relative: '相对',
        special: '特殊日期',
        current: '当前',
        previousDay: '上一',
        previousWeekDay: '上周同一',
        specialDate: `特殊日期`,
        specialDateConent: `时间组件支持特殊日期（非自然日）选项，例如交易日、工作日等，需要在账号设置中心设置特殊日期，设置完成后将在时间组件看到相关选项，特殊日期选项说明如下：
    ● 当前特殊日期：查询当天范围内的数据，如果当天为非特殊日期，特殊日期选项不可用
    ● 上一特殊日期：按照当前时间对比，查询上一特殊日期的数据
    ● 上周同一特殊日期：按照当前时间对比，查询上周同一天的数据，如果上周同一天为非特殊日期，特殊日期选项不可用`,
    },
};
// should add whitespace between char in Button
locale.lang.ok = '确定';
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
export default locale;
